import {useState, useEffect, useContext} from 'react';
import { useReactMediaRecorder } from "react-media-recorder";
import sentences from './sentences.json';
import languageJSON from './languages.json';
import { ProfileContext } from './contexts/profileContext';
import  { ErrorContext } from './contexts/errorContext';
import { useNavigate } from 'react-router-dom';
export default function Practice() {
  const apiURL = process.env.REACT_APP_ENVIRONMENT === 'development' ? process.env.REACT_APP_DEV_API_URL : process.env.REACT_APP_PROD_API_URL;
  const navigate = useNavigate();
  const { userProfile } = useContext(ProfileContext);
  const {showError} = useContext(ErrorContext);
  const { status, startRecording, stopRecording, mediaBlobUrl } = useReactMediaRecorder({ audio: true, type: "audio/webm"});
  // game-start, reader
  const [popup, setPopup] = useState({state: 'game-start', data: null});
  const [difficulty, setDifficulty] = useState('easy');
  const [language, setLanguage] = useState('chinese');
  const [sentence, setSentence] = useState(null);
  const [detectedSentence, setDetectedSentence] = useState(null);
  // states: not-started, in-game, loading, finished, expired
  const [gameStatus, setGameStatus] = useState({
    state: 'not-started',
    data: null
  });

  const handleTrial = async () => {
    if (userProfile && userProfile.isPaid) {
      setGameStatus({state: 'not-started', data: null})
      return;
    }
    // check if local storage has trial key
    if (localStorage.getItem('trial')) {
      if (localStorage.getItem('trial') <= '0') {
        setGameStatus({state: 'expired', data: null})
      }
    }
    else {
      localStorage.setItem('trial', 3);
    }
  }

  const handlePronounce = (e) => {
    e.preventDefault();
    let speech = new SpeechSynthesisUtterance();
    speech.lang = languageJSON[language]["IETF"];
    speech.text = e.target[0].value;
    window.speechSynthesis.speak(speech);
  }

  const handleRecord = async () => {
    if (status === 'recording') {
      stopRecording();
      setGameStatus({state: 'loading', data: null});
    }
    else {
      if (userProfile && !userProfile.isPaid && localStorage.getItem('trial') <= '0') {
        setGameStatus({state: 'expired', data: null});
        return;
      }
      if (!MediaRecorder.isTypeSupported('audio/webm')) {
        showError('Your browser does not support recording audio. Please use Chrome or a non-mobile device.');
        return;
      }
      startRecording();
      setDetectedSentence(null);
    }
  }

  const getProblem = () => {
    let sentenceChoices = sentences[difficulty];
    let sentence = sentenceChoices[Math.floor(Math.random() * sentenceChoices.length)];
    setSentence(sentence.sentence);
  }

  const getTranslationHelp = () => {
    setDetectedSentence(null);
    setGameStatus({state: 'loading', data: null});
    fetch(`${apiURL}/get-translation-help`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({originalSentence: sentence, language: language})
    })
      .then(response => response.json())
      .then(data => {
        setGameStatus({state: 'finished', data: data.response});
      })
      .catch(error => {
        showError('Something went wrong. Please try again.');
      }
    );
  }

  useEffect(() => {
    handleTrial();
    getProblem();
  }, [userProfile]);

  useEffect(() => {
    if (mediaBlobUrl) {
      async function processBlob(url) {
        let blob = await fetch(mediaBlobUrl).then(r => r.blob());
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64String = reader.result;
          sendAudioToServer(base64String);
        }
      }

      async function sendAudioToServer(base64String) {

        fetch(`${apiURL}/upload-audio`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({audioBlob: base64String, language: language, originalSentence: sentence})
        })
          .then(response => response.json())
          .then(data => {
            setGameStatus({state: 'finished', data: data.response});
            setDetectedSentence(data.transcription);
            let trial = localStorage.getItem('trial');
            localStorage.setItem('trial', trial - 1);
          })
          .catch(error => {
            showError('Something went wrong. Please try again.');
          });
      }
      processBlob(mediaBlobUrl);
    }
  }, [mediaBlobUrl]);

  return (
    <>
    <div className={`absolute h-screen bg-white z-10 grid place-content-center p-3 ${popup.state === 'reader' ? '' : 'hidden'}`} style={{width: 'calc(100vw - (100vw - 100%))', height: 'calc(100vh - 92px)'}}>
      {/* x button to close */}
      <div className='flex justify-end'>
        <span className="py-2 px-4 cursor-pointer text-5xl" onClick={() => {setPopup({state: null, data: null})}}>×</span>
      </div>
      <form className='text-center flex flex-col gap-8 max-w-3xl' onSubmit={handlePronounce}>
        <p className="text-2xl">Want to know how to pronounce certain words/sentences correctly? Just enter them below!</p>
        <textarea className="border border-gray-300 rounded-md p-2" maxLength={125}  placeholder="Enter text here"></textarea>
        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Pronounce</button>
      </form>
    </div>
    {
      gameStatus.state === "expired" &&
        <div className=' bg-white grid place-content-center' style={{width: 'calc(100vw - (100vw - 100%))', height: 'calc(100vh - 92px)'}}>
        <div className='text-center flex flex-col gap-8'>
          <h1 className="text-4xl font-bold mt-auto">Trial Expired</h1>
          <p className="text-2xl max-w-3xl">We can only let everyone play 3 rounds because this is an early product. But we're offering full access for a limited 35$ one-time fee before it becomes a subscription. If you're interested, {!userProfile ? 'login' : 'Buy Pro'}.</p>
          { !userProfile && <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={() => {navigate('/signin')}}>Login</button>}
          { userProfile && !userProfile.isPaid && <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={() => {navigate('/payment')}}>Buy Pro</button>}
        </div>
        </div>
    }
    {
      gameStatus.state === "not-started" &&
      <div className={`bg-white z-10 px-5 grid place-content-center p-3 ${popup.state === 'game-start' ? '' : 'hidden'}`} style={{height: "calc(100vh - 92px)"}}>
      <div className='text-center flex flex-col gap-8 max-w-3xl'>
        <h1 className="text-4xl font-bold mt-auto">Welcome</h1>
        <p className="text-2xl">lingologue is a language learning game that helps you improve your speaking skill by giving you instant feedback on your translations.</p>
        <div>
          <label class="block text-sm font-medium text-gray-900 text-left mb-1">Select a language</label>
          <select value={language} onChange={(e)=>{setLanguage(e.target.value)}} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
            <option value="chinese">Chinese</option>
            <option value="spanish">Spanish</option>
            <option value="french">French</option>
            <option value="russian">Russian</option>
            <option value="japanese">Japanese</option>
            <option value="korean">Korean</option>
          </select>
        </div>
        
        <div>
          <label class="block text-sm font-medium text-gray-900 text-left mb-1">Select a difficulty</label>
          <select value={difficulty} onChange={(e)=>{setDifficulty(e.target.value)}} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
            <option value="easy">Easy</option>
            <option value="medium">Medium</option>
            <option value="hard">Hard</option>
          </select>
        </div>
        
        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={() => {getProblem();setGameStatus({state: 'in-game', data: null})}}>Play</button>

      </div>
    </div>
    }
    {
      ["in-game", "loading", "finished"].includes(gameStatus.state) &&
      <div className="App text-center flex flex-col" style={{height: "calc(100vh - 92px)"}}>

        {/* selected settings */}
        <section className='flex justify-center py-2 gap-4'>
          <p>{languageJSON[language]['emoji'] + ' ' + language.charAt(0).toUpperCase() + language.slice(1)}</p>
          <p className={`font-semibold ${difficulty === 'easy' ? 'text-green-600' : difficulty === 'medium' ? 'text-orange-500' : 'text-red-600'}`}>{difficulty.toUpperCase()}</p>
        </section>
        
        <div className="flex grow">
          <section className="w-1/2 grid place-content-center border-r-4 border-black">
            <div className='flex flex-col gap-5'>
              <p className="text-xl md:text-2xl">translate this sentence:</p>
              <p className="text-2xl md:text-3xl">"{sentence}"</p>
              <button className={`w-20 h-20 border-4 border-black rounded-full p-3 m-auto cursor-pointer ${status === 'recording' ? 'bg-blue-300' : 'bg-white'}`} onClick={handleRecord}>
                <img className="w-20" src={require("./img/mic.png")} alt="Click to speak"/>
              </button>
              {/* {(gameStatus.state === 'loading' || gameStatus.state === 'finished') && <audio className='m-auto' controls src={mediaBlobUrl}></audio>} */}
              {detectedSentence && <p className="text-2xl">{detectedSentence}</p>}
              {
                gameStatus.state === "finished" && 
                <div className='flex justify-center gap-4'>
                  <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={() => { 
                    if (status === 'recording') {
                      return;
                    }
                    setDetectedSentence(null);
                    getProblem();
                    setGameStatus({state: 'in-game', data: null}) 
                    } }
                    disabled={status === 'recording'}
                    >Next</button>
                </div>
              }
              <p class="font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer" onClick={getTranslationHelp}>No clue how to translate this?</p>
              <p class="font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer" onClick={()=>setPopup({state: 'reader', data: null})}>Check pronunciation with lingologue reader</p>
            </div>
            
          </section>

          <section className={`${gameStatus.state === 'finished' ? '' : 'place-content-center'} w-1/2 grid pt-10 p-6 text-left overflow-y-auto`} style={{height: 'calc(100vh - 172px)'}}>
            {
              gameStatus.state === "loading" ? <div class="lds-dual-ring"></div> : gameStatus.state === "finished" ? <pre className="text-2xl whitespace-pre-wrap">{gameStatus.data}</pre> : <p className="text-2xl">Feedback will be shown here</p>
            }
          </section>
        </div>
        
      </div>
    }

    
    </>
    
  );
}

